// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"lineChart_hideScrollbar__3EwsI","tick":"lineChart_tick__rmy0D","customcheckbox":"lineChart_customcheckbox__EDdh0"};